import { useQuery } from "@tanstack/react-query"
import { authorizedFetch } from "@/lib/api"

const API_URL = import.meta.env.VITE_API_URL as string

/**
 * Returns a stable presigned S3 URL for a client avatar.
 * Cached for 50 minutes — survives shipment list refetches without flickering.
 * Returns null when the client has no avatar or clientId is null/undefined.
 */
export function useClientAvatarUrl(clientId: string | null | undefined): string | null {
  const { data } = useQuery<{ signedUrl: string | null }>({
    queryKey:  ["client-avatar-url", clientId],
    enabled:   !!clientId,
    staleTime: 50 * 60 * 1000, // 50 min — S3 presign TTL is 60 min
    gcTime:    60 * 60 * 1000, // keep in cache for 60 min
    queryFn:   async () => {
      const res = await authorizedFetch(`${API_URL}/api/clients/${clientId}/avatar-url`)
      return res.json()
    },
  })
  return data?.signedUrl ?? null
}
